import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, QueryList, TemplateRef, ViewChild, ViewChildren } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';   
import { MatPaginator } from '@angular/material/paginator';   
import { MatTableDataSource } from '@angular/material/table';   
import { DatabaseGwService } from "../../../rds-objects/services/database-gw.service";
import { get } from 'lodash';

@Component({
	selector: 'rds-lookup-field',
	templateUrl: './lookup-field.component.html',
	styleUrls: ['./lookup-field.component.scss']
})
export class LookupFieldComponent implements OnInit, AfterViewInit {

	formFieldAppearance: string = "outline";
	@Input() apiRoute: string = '';  /** required: table name */
	@Input() filterRecord: any = {}; /** Filter to get custom data */
	@Input() columnNames: any[] = []; /** Table column name: fieldName , colName  */
	//e.g.
	//fieldName = "name"              //temporary fieldname 
	//fieldValue = "langs.en.name",  //field value that we want to display
	//colName = "Name"                //column name display in popup table
	//isHide = false               //if this field no need to display in table
	@Input() size: string = "sm"; //Optional, default: sm, md, xl
	
	@Input() dialogTitle: string = "Choose your record"; /** Dialog title */
	@Input() hasCreate: boolean = false;
	@Output() recordEmitter = new EventEmitter();
	@Output() callbackNew = new EventEmitter();

	// For input field style
	@Input() value: any = ""; /** required Input value */
	@Input() label: string = "Label"; /** Label to show with data */
	@Input() placeholder: string = ""; /** Placeholder to show whenever there's no data */
	@Input() isHideButtons: boolean = false; /** Hide all action buttons */
	@Input() isRequire: boolean = false;
	@Input() isDisable: boolean = false;
	@Input() isViewable: boolean = false;
	@Input() viewLink: string = '';
	@Input() inputType: string = 'mat';//mat (field), bootstrap (inline)

	isRefreshing: boolean = false;
	isLoading: boolean = true;
	lstRecords = new MatTableDataSource<any>();
	columsDef: string[] = [];

	@ViewChild("popUpDialog", { static: true }) popUpDialog: TemplateRef<any>;
	@ViewChildren(MatPaginator) paginator = new QueryList<MatPaginator>();

	constructor(
		private _MatDialog: MatDialog,
		private $dataBase: DatabaseGwService,
	) {

	}

	ngAfterViewInit() {

	}

	ngOnInit() {
		this.onLoadRecords();

		//setup column to display
		this.columnNames.forEach((column, index) => {
			if(!column.isHide){
				this.columsDef.push(column.fieldName);
			}
			
		});
		this.columsDef.push("actions"); /** For select column */
	}

	onLoadRecords() {
		let apiPath: string = this.apiRoute || '/error-object';

		this.isLoading = true;

		this.$dataBase.query(this.filterRecord, apiPath).subscribe(result => {

			this.lstRecords = new MatTableDataSource<any>(this.fetchData(result.data));

			/** Override filter so we can search in nested object */
			this.lstRecords.filterPredicate = (data: any, filter) => {
				const dataStr = JSON.stringify(data).toLowerCase();
				return dataStr.indexOf(filter) != -1;
			}

			this.isLoading = false;
			this.isRefreshing = false;
		}, error => {
			this.isLoading = false;
			this.isRefreshing = false;
			console.log(error.message);
		});
	}

	fetchData(lstRecords: any[]) {

		let lstFetchedData: any[] = [];
		lstRecords.forEach(record => {
			let newObj: any = {};
			Object.assign(newObj, record); /** Assign every field from record to new object */
			this.columnNames.forEach(col => {
				newObj[col.fieldName] = get(record, col.fieldValue);// record["langs.en.name"]
			});
			lstFetchedData.push(newObj);
		});

		return lstFetchedData;
	}

	onOpenDialog() {
		if (!this.value) {
			this._MatDialog.open(this.popUpDialog, { width: this.size == "sm" ? "50vw" : this.size == "lg" ? "77vw" : "60vw" });
			setTimeout(() => {
				this.lstRecords.paginator = this.paginator.toArray()[0];
			}, 0);
		}
	}

	onClearData() {
		this.value = "";
		this.recordEmitter.emit({});//WHY NEED Emit THIS?
		/** Emit empty string value to let the parent component knows that value has changed/cleared */
	}

	onSelect(record: any) {
		this.recordEmitter.emit(record);
		this._MatDialog.closeAll();
	}

	callbackCreate() {
		this.callbackNew.emit();
	}

	onSearch(filterValue: string) {
		this.lstRecords.filter = filterValue.trim().toLowerCase();
	}

	onRefresh() {
		this.lstRecords = new MatTableDataSource<any>();
		this.isLoading = true;
		this.isRefreshing = true;
		this.onLoadRecords();
	}

}
